import { Check } from 'iconoir-react';
import { FC } from 'react';

import { LANGUAGES } from '@savgroup-front-common/constants';
import { SafeFormattedMessageWithoutSpread } from '@savgroup-front-common/core/formatters';
import { DropdownMenuItem } from '@savgroup-front-common/primitive/ui/dropdown-menu';

import { useProfileActions } from '../../../hooks/useProfileActions';
import { useProfileData } from '../../../hooks/useProfileData';

import messages from './messages';

interface HeaderProfileMenuLanguageItemsProps {
  onSelect: () => void;
}

export const HeaderProfileMenuLanguageItems: FC<
  HeaderProfileMenuLanguageItemsProps
> = ({ onSelect }) => {
  const { languages, locale } = useProfileData();
  const { updateIntl } = useProfileActions();

  return (
    <>
      {(languages ?? []).map((language) => {
        const upperLanguage = language.toUpperCase() as keyof typeof LANGUAGES;
        const key = LANGUAGES[upperLanguage];
        const isCurrent = locale === key;

        return (
          <DropdownMenuItem
            key={key}
            data-testid={`headerProfileLanguage_${key}`}
            onSelect={() => {
              updateIntl(key);
              onSelect();
            }}
          >
            <span className="flex size-5 shrink-0 items-center justify-center">
              {isCurrent && <Check />}
            </span>
            <span className="flex-1 truncate">
              <SafeFormattedMessageWithoutSpread message={messages[language]} />
            </span>
          </DropdownMenuItem>
        );
      })}
    </>
  );
};
